export default {
    spec_fuel_petrol: 'gas',
    spec_fuel_petrol_diesel: 'diesel/benzin',
    excess: 'Haftpflichtversicherung mit Ausfalldeckung',
    security: 'Kaution',
    fuel_policy: 'Treibstoff-Richtlinie',
    like_for_like: 'LFL',
    full_to_full: 'Voll abholen, voll abgeben',
    mileage: 'Reichweite: {mileage} kostenlose Meilen pro Mietwagen',
    unlimited_mileage: 'Unbegrenzte Reichweite',
    non_refundable: 'Nicht erstattbar',
    free_cancellation_until: 'Kostenlose Stornierung bis {date}',
    cancellation_with_terms: 'Stornierung {0} in Übereinstimmung mit ',
    t_c_text: 'AGBs',
    two_free_extras: 'Zwei Gratis-Extras bei Abholung',
    glass_tyres_covered: 'Glas und Reifen versichert',
};
